import React, { Component } from "react";
import CustomerMobileHeader from "./../Layout/CustomerMobileHeader";
import { Route } from "react-router-dom";
import Header from "../Layout/PostPaidHeader";
import Footer from "../Layout/Footer";
import NbnChangePlan from "../ProtectedComponents/NBN/NbnChangePlan";
import swal from "sweetalert";
import ForbiddenPage from "../ForbiddenPage";
import { getToken } from "../../utils/CommonFunctions";
import ChangePassword from "../ProtectedComponents/PostPaid/ChangePassword";
import AddNbn from "../ProtectedComponents/NbnAdd/AddNbn";
import Connection from "../ProtectedComponents/NbnAdd/Checkout/Connection";

///////////

import PostPaidServiceList from "../ProtectedComponents/PostPaid/PostPaidServiceList"
import PostPaidNavigation from "../Layout/PostPaidNavigation";
import PostPaidAccountSummary from "../ProtectedComponents/PostPaid/PostPaidAccountSummary";
import PostPaidMyProfile from "../ProtectedComponents/PostPaid/PostPaidMyProfile"
import PostPaidMyPayment from "../ProtectedComponents/PostPaid/PostPaidMyPayment";
import PostPaidActivate from "../ProtectedComponents/PostPaid/activation";
import PostPaidChangePlan from "../ProtectedComponents/PostPaid/PostPaidChangePlan";
import SimServices from "../ProtectedComponents/PostPaid/SimServices";
import PostPaidAddPacks from "../ProtectedComponents/PostPaid/PostPaidAddPacks";
import Activatev2 from "../ProtectedComponents/PostPaid/Activatev2";
import AddAMobilePlan from "../ProtectedComponents/PostPaid/AddAMobilePlan";
import SimOnlyIDsuccess  from  "../ProtectedComponents/PostPaid/SimOnlyIDsuccess"       
import SImOnlyIDverification from "../ProtectedComponents/PostPaid/SImOnlyIDverification" 
import PostpaidDataGifting from "../ProtectedComponents/PostPaid/PostpaidDataGifting" 
import Navigation from "../Layout/Navigation";
import WmeRecharge from "../../components/ProtectedComponents/PostPaid/WMEPrepaid/Recharge"
import PrepaidToPostpaidMigration from "../../components/ProtectedComponents/PostPaid/prepaidToPostpaidMigration"                                  

import WmeServiceMigration from "../../components/ProtectedComponents/PostPaid/wmeServiceMigration";

  



export default class PostPaidProtectedComponents extends Component {

    isPerimissionForAccess = () => {
        const isPerimissionForAccessUrl = sessionStorage.getItem('is_postpaid');
        return isPerimissionForAccessUrl  
    }

     isWmeCustomer  = ()=> {
    return  sessionStorage.getItem('is_wme_customer') === '1';
     } 






    render() {
        const isPerimissionForAccessUrl = this.isPerimissionForAccess();
        if (isPerimissionForAccessUrl ==='0') {
           return <ForbiddenPage></ForbiddenPage>
        }

         const isWmeCustomer = this.isWmeCustomer();


        return <>
            <CustomerMobileHeader />
            <div className="kt-grid kt-grid--hor kt-grid--root">
                <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
                              <PostPaidNavigation/>    
                         
                    <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
                        <Header />
                        <Route path="/my-service-list" exact component={() => <PostPaidServiceList/>} />
                          <Route path="/account-summary" exact component={() => <PostPaidAccountSummary/>} />
                          <Route path="/my-profile" exact component={() => <PostPaidMyProfile/>} />
                          <Route path="/my-payments" exact component={() => <PostPaidMyPayment/>} />
                          <Route path="/activatev3" exact component={() => <Activatev2/>} />
                          <Route path="/change-plan" exact component={() => <PostPaidChangePlan/>} />
                          <Route path="/add-packs" exact component={() => <PostPaidAddPacks/>} />
                          <Route path="/sim-services" exact component={() => <SimServices/>} />
						  {/* <Route path="/nbn_change_password" exact component={() => <ChangePassword />} />  */}
                          <Route path="/nbn_change_plan" exact component={() => <NbnChangePlan/>} />
                          <Route path="/Add_Nbn" exact component={() => <AddNbn/>} />
                          <Route path="/Nbn_connection" exact component={() => < Connection/>} />
                          <Route path='/change_password' exact component={() => <ChangePassword />} />
                          <Route path='/add_a_mobile_plan' exact component={() => <AddAMobilePlan />} />
                          <Route path='/SImOnlyIDverification' exact component={() => <SImOnlyIDverification />} />
                          <Route path='/SimOnlyIDsuccess' exact component={() => <SimOnlyIDsuccess />} />
                          <Route path='/data-gifting' exact component={() => <PostpaidDataGifting />} />
                          <Route path="/recharge"  component={() => <WmeRecharge />} />
                          <Route path="/sim-only-migration"  component={() => <PrepaidToPostpaidMigration />} />
                          <Route  path="/service-migration" component={() => <WmeServiceMigration />} />                          
                        <Footer />
                    </div>
                </div>
            </div>
            <div id="kt_scrolltop" className="kt-scrolltop">
                <i className="la la-arrow-up"></i>
            </div>
        </>
    }
}